// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1lt97","loading":"Button_loading__1xNkS","hide-loading":"Button_hide-loading__1cUCz","text":"Button_text__3n5DA"};